import { Close } from '@mui/icons-material';
import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  Toolbar,
  Typography,
} from '@mui/material';
import React from 'react';
import Reminders from '../../Reminders';

const RemindersDialog = ({
  openReminders,
  handleCloseReminders,
  open,
  onClose,
  patient,
  currentPatient,
  isTeacherContext = false,
}) => {
  const dialogOpen = typeof open !== 'undefined' ? open : openReminders;
  const handleClose = onClose || handleCloseReminders;

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='customized-dialog-title'
      open={dialogOpen}
      maxWidth='lg'
      className='mindly-reminders'
      PaperProps={{
        sx: {
          borderRadius: '20px',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 25px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(10px)',
        }
      }}
    >
      <AppBar
        sx={{
          position: 'relative',
          background: 'linear-gradient(135deg, #9291f0 0%, #7c7be8 100%)',
          boxShadow: '0 4px 20px rgba(146, 145, 240, 0.3)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', px: 3, py: 1.5 }}>
          <div style={{ width: '48px' }}></div>
          <Typography
            sx={{
              color: 'white',
              fontSize: '1.75rem',
              fontFamily: 'Lato, sans-serif',
              fontWeight: 700,
              flex: 1,
              textAlign: 'center',
              letterSpacing: '-0.5px',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
            }}
            variant='h6'
            component='div'
          >
            Reminders
          </Typography>
          <Button 
            autoFocus 
            color='inherit' 
            onClick={handleClose}
            sx={{ 
              minWidth: '48px',
              p: 0,
              borderRadius: '12px',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                transform: 'scale(1.05)',
              }
            }}
          >
            <Close sx={{ 
              color: 'white',
              fontSize: '1.5rem',
            }} />
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent
        sx={{
          width: '42vw',
          backgroundColor: 'white',
          padding: '32px',
          '&.MuiDialogContent-root': {
            padding: '32px',
          },
          '& .Reminders': {
            backgroundColor: 'white !important',
          },
          '& .fullWidth.fullHeight.flexBox.flexColumn.Reminders': {
            backgroundColor: 'white !important',
          },
          '& *': {
            backgroundColor: 'transparent',
          },
          '& .MuiBox-root': {
            backgroundColor: 'white !important',
          },
          // Modern input styling
          '& .MuiInputBase-root': {
            borderRadius: '12px',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              boxShadow: '0 2px 8px rgba(146, 145, 240, 0.1)',
            },
            '&.Mui-focused': {
              boxShadow: '0 0 0 3px rgba(146, 145, 240, 0.1)',
            }
          },
          // Modern button styling
          '& .MuiButton-root': {
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-1px)',
              boxShadow: '0 4px 12px rgba(146, 145, 240, 0.3)',
            }
          },
          // Modern radio button styling
          '& .MuiRadio-root': {
            '&.Mui-checked': {
              color: '#9291f0',
            }
          },
          // Modern checkbox styling
          '& .MuiCheckbox-root': {
            '&.Mui-checked': {
              color: '#9291f0',
            }
          },
          // Calendar styling
          '& .react-calendar': {
            borderRadius: '16px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
            overflow: 'hidden',
          },
          // Typography improvements
          '& .MuiTypography-root': {
            fontFamily: 'Lato, sans-serif',
            fontWeight: 500,
          },
          // Label styling
          '& label': {
            fontWeight: 600,
            color: '#333',
            marginBottom: '8px',
            display: 'block',
          }
        }}
      >
        <Reminders
          patient={patient}
          currentPatient={currentPatient}
          isOpen={dialogOpen}
          isTeacherContext={isTeacherContext}
        />
      </DialogContent>
    </Dialog>
  );
};

export default RemindersDialog; 